module.exports = __webpack_public_path__ + "static/img/twjd-sdc3.8b8031a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdc3.png
// module id = 833
// module chunks = 0